import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as icon from './icon'

/**
 * Component for displaying notice messages with different styles and descriptions
 *
 * Displays notice boxes with icon and description based on the {@link ents.core.display.Style | Style } input.
 * Supports Success, Warning, Danger, and Info styles.
 *
 * @example
 * ```html
 * <atn-ds-notice
 *   [style]="Style.Success"
 *   description="Your changes have been saved successfully"
 * />
 * ```
 */
@ngCore.Component({
  imports: [icon.Component, ngCommon.NgClass],
  selector: 'atn-ds-notice',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Style input indicating which notice style should be shown.
   *
   * @see {@link ents.core.display.Style}
   */
  public readonly styleSg = ngCore.input(ents.core.display.Style.Info, {
    alias: 'style',
  })

  /**
   * Description text to be displayed in the notice. When omitted, use content
   * projection to supply the description as HTML.
   */
  public readonly descriptionSg = ngCore.input<string | undefined>(undefined, {
    alias: 'description',
  })

  /**
   * Style enum exposed to HTML
   *
   * @see {@link ents.core.display.Style}
   */
  public readonly StyleEnum = ents.core.display.Style
}
